import { RetailRocketEffects } from './retail-rocket-effects';

export const effects: any[] = [RetailRocketEffects];
